import { ItemContainerCreator } from "./item-container-creator";
import { GraphicTable, FixedDimension, PercentDimension } from "../../../../../web-graphics";

export class TableCreator extends ItemContainerCreator {
  constructor(commonSettings) {
    super(commonSettings);
  }

  static prepareSettings(settings) {
    settings.location = {
      x: settings.x?.copy() ?? new FixedDimension(0),
      y: settings.y?.copy() ?? new FixedDimension(0)
    };
    settings.size = {
      width: settings.width?.copy() ?? new PercentDimension(1),
      height: settings.height?.copy() ?? new PercentDimension(1)
    };
    settings.parent = {
      ref: settings._parentObject
    };
    for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
      const rowSettings = settings.rows[rowIndex];
      if (rowSettings.height === undefined) {
        rowSettings.height = new PercentDimension(1);
      }
    }
    for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
      const columnSettings = settings.columns[columnIndex];
      if (columnSettings.width === undefined) {
        columnSettings.width = new PercentDimension(1);
      }
    }
  }

  static createItems(itemsSettings, viewObjectCreators, tableObject, canvasObject, idGenerator, creator) {
    if (itemsSettings === undefined || !Array.isArray(itemsSettings)) {
      return;
    }
    let calllbackArray = creator.callbacks.get("beforeAddItems");
    calllbackArray.forEach(callback => callback(tableObject, itemsSettings, creator));
    for (let rowIndex = 0; rowIndex < itemsSettings.length; rowIndex++) {
      let rowItems = itemsSettings[rowIndex] ?? [];
      for (let columnIndex = 0; columnIndex < rowItems.length; columnIndex++) {
        let parentPanel = tableObject.settings.rows[rowIndex].columns[columnIndex].drawablePanel;
        if (parentPanel != null) {
          ItemContainerCreator.createItem(rowItems[columnIndex], viewObjectCreators, parentPanel, canvasObject, idGenerator, item => {
            tableObject.addItem(rowIndex, columnIndex, item);
          });
        }
      }
    }
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    TableCreator.prepareSettings(settings);
    const tableObject = new GraphicTable(settings);
    TableCreator.createItems(
      settings.items,
      settings._viewObjectCreators,
      tableObject,
      settings._canvasObject,
      settings._idGenerator,
      this
    );
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(tableObject, settings, this));
    return tableObject;
  }
}
